// frontend/src/components/landing/sections/ResearchTeams.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Chip, Container, LandingButton, Reveal, Section } from '../parts';
import { tokens } from '../landingTheme';

export const LAB_EMAIL = 'yesnlplab@kennesaw.edu';

// Split card: heading on the left, copy and the contact link on the right, on a peach-to-navy wash
const ResearchTeams = () => (
    <Section id="research" aria-labelledby="research-title">
        <Container>
            <Reveal
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: '5fr 7fr' },
                    alignItems: 'center',
                    gap: { xs: 3, md: 8 },
                    p: { xs: 4, md: 8 },
                    borderRadius: 8,
                    background: `linear-gradient(120deg, ${tokens.highlightTint} 0%, ${tokens.accentTint} 100%)`,
                    border: `1px solid ${tokens.line}`,
                }}
            >
                <Box>
                    <Chip sx={{ bgcolor: tokens.surface, color: tokens.ink, mb: 2, boxShadow: `inset 0 0 0 1px ${tokens.line}` }}>
                        Coming next
                    </Chip>
                    <Typography id="research-title" variant="h2" component="h2">
                        For research teams
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="subtitle1" component="p" sx={{ color: tokens.ink, maxWidth: 600 }}>
                        Trained coders annotate whole lessons, and disputed labels are re-coded blind and resolved. Every
                        label keeps its history, and the agreed labels help retrain the classifier.
                    </Typography>
                    <LandingButton
                        variant="secondary"
                        href={`mailto:${LAB_EMAIL}?subject=${encodeURIComponent('ADAS for research teams')}`}
                        arrow
                        sx={{ mt: 3 }}
                    >
                        Learn more
                    </LandingButton>
                </Box>
            </Reveal>
        </Container>
    </Section>
);

export default ResearchTeams;
